import { easyMatchKeys } from "@/entities/easy-match"
import { friendKeys, upsertConfirmedFriendInCache } from "@/entities/friend"
import { showNotification } from "@/entities/notification"
import { registerNotification } from "@/shared/api/websocket"

registerNotification("friend_response_notification", {
	handle: ({ notification_id, data }, ctx) => {
		ctx.queryClient.invalidateQueries({
			queryKey: easyMatchKeys.status(ctx.userId),
		})

		upsertConfirmedFriendInCache(ctx.queryClient, ctx.userId, data.friend)
		ctx.queryClient.invalidateQueries({
			queryKey: friendKeys.list(ctx.userId),
			refetchType: "none",
		})
		showNotification({
			type: "friend-response",
			placement: "home",
			friend: data.friend,
			origin: "server",
			name: "friend_response_notification",
			notificationId: notification_id,
		})
	},
	route: () => ({ to: "/home" }),
	routePopup: null,
})
